import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast';
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from './context/AuthProvider';
import store from "./store";
import router from "./config/router";
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <Toaster position='bottom-right'/>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </Provider>
)
